import { FunctionComponent, Fragment } from 'react';
import type * as T from './FilterTabs.types';
import Tabs from '@media-ui/core/src/components/Tabs';
import TabsMore from '@media-ui/core/src/components/TabsMore';
import * as filterStyles from './FilterStyles.css';
import type { ITabsMoreItemProps } from '@media-ui/core/src/components/TabsMore/TabsMore.types';
import { counterTrigger } from 'Src/tools/counters';
import Link from '@media-ui/core/src/components/Link';
import { useAppContext } from 'Src/containers/App/App.context';
import { useBreakpointsChecker } from '@media-ui/core/src/hooks/useBreakpointsChecker/useBreakpointsChecker';
import classNames from 'classnames';
export const FilterTabs: FunctionComponent<T.IFilterTabsProps> = (props) => {
    const { className, items, selectedTab = items[0].alias, onChange, clickCounter, isLinks, type, isLoading, stroke, children, } = props;
    const { layout: { custom: { isMobile }, }, } = useAppContext();
    const [screen] = useBreakpointsChecker({ isTouch: isMobile });
    const TabsComponent = (screen.isTouch ? Tabs : TabsMore) as typeof TabsMore;
    const handleChange = (id: string, tab: ITabsMoreItemProps) => {
        const item = items.find((i) => i.alias === id);
        if (clickCounter) {
            counterTrigger(clickCounter);
        }
        if (item?.rubric_url && id !== selectedTab) {
            return;
        }
        if (typeof onChange === 'function') {
            onChange(id, tab);
        }
    };
    const tabItems = items.map((filter) => {
        const isRubricLink = filter.rubric_url && filter.alias !== selectedTab;
        return (<TabsComponent.Item className={filterStyles.tab} key={filter.alias} id={filter.alias} type={type} stroke={stroke} {...filter}>
        {isLinks ? (<Link className={filterStyles.link} holder href={filter.url}>
            {filter.title}
          </Link>) : isRubricLink ? (<Link className={filterStyles.link} href={filter.rubric_url}>
            {filter.title}
          </Link>) : (filter.title)}
      </TabsComponent.Item>);
    });
    return (<Fragment>
      {children}
      {items.length && (<div className={classNames(className, {
                [filterStyles.isLoading]: isLoading,
            })}>
          <TabsComponent className={filterStyles.tabList} data-qa="FilterTabs" selected={selectedTab} onChange={handleChange}>
            {tabItems}
          </TabsComponent>
        </div>)}
    </Fragment>);
};
